import { GetFabVehicleImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabVehicleImages/getFabVehicleImagesQuery.type';
import { getFabVehicleImagesFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabVehicleImages/getFabVehicleImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getFabVehicleImagesQueryOptions = (
  params: GetFabVehicleImagesQueryParamsType,
) => {
  const generateUrl = (state: GetFabVehicleImagesQueryParamsType['state']) => {
    switch (state) {
      case 'bodyAdjusterVehicle':
        return `body/reports/${params.id}/fab/adjuster/vehicle/`;
      case 'bodyCustomerVehicle':
        return `body/reports/${params.id}/fab/customer/vehicle/`;
      case 'initialAdjusterVehicle':
        return `initial/reports/${params.id}/fab/adjuster/vehicle/`;
      case 'initialCustomerVehicle':
        return `initial/reports/${params.id}/fab/customer/vehicle/`;
      case 'propertyCulpritAdjusterVehicle':
        return `property/reports/${params.id}/accident_users/culprit/fab/adjuster/vehicle/`;
      case 'propertyCulpritCustomerVehicle':
        return `property/reports/${params.id}/accident_users/culprit/fab/customer/vehicle/`;
      case 'propertyDamagedAdjusterVehicle':
        return `property/reports/${params.id}/accident_users/damaged/fab/adjuster/vehicle/`;
      case 'propertyDamagedCustomerVehicle':
        return `property/reports/${params.id}/accident_users/damaged/fab/customer/vehicle/`;
    }
  };

  return queryOptions({
    queryKey: ['fabVehicleImages', params],
    queryFn: () =>
      getFabVehicleImagesFunction({
        url: generateUrl(params.state),
        damagedId: params.damagedId,
      }),
    enabled: true,
  });
};
